import { useState, useEffect, useRef } from 'react';
import * as TablerIcons from '@tabler/icons-react';

const componentMap = {
  './pages/Dashboard': () => import('../pages/Dashboard'),
  './pages/Factures': () => import('../pages/Factures'),
  './pages/Reglements': () => import('../pages/Reglements'),
  './pages/PointageComptable': () => import('../pages/PointageComptable'),
  './pages/DevTodo': () => import('../pages/DevTodo'),
  './pages/Planning': () => import('../pages/Planning'),
  './pages/Controles': () => import('../pages/Controles'),
  './pages/Statistiques': () => import('../pages/Statistiques'),
  './pages/statistiques/StatistiquesSynthese': () => import('../pages/statistiques/StatistiquesSynthese'),
  './pages/statistiques/StatistiquesEvolution': () => import('../pages/statistiques/StatistiquesEvolution'),
  './pages/statistiques/StatistiquesClients': () => import('../pages/statistiques/StatistiquesClients'),
  './pages/statistiques/StatistiquesDetailClient': () => import('../pages/statistiques/StatistiquesDetailClient'),
  './pages/statistiques/StatistiquesPrevisions': () => import('../pages/statistiques/StatistiquesPrevisions'),
  './pages/admin/Exploitations': () => import('../pages/admin/Exploitations'),
  './pages/admin/InitData': () => import('../pages/admin/InitData'),
  './pages/admin/FactureReglementLinksRepair': () =>
    import('../pages/admin/FactureReglementLinksRepair'),
  './pages/admin/ModuleHelp': () => import('../pages/admin/ModuleHelp'),
  './pages/admin/ServerStatus': () => import('../pages/admin/ServerStatus'),
  './pages/admin/LoginEvents': () => import('../pages/admin/LoginEvents'),
  './pages/tenant/ParametresExploitant': () => import('../pages/tenant/ParametresExploitant'),
  './pages/tenant/BaseDeDonnees': () => import('../pages/tenant/BaseDeDonnees'),
  './pages/tenant/ProfilUtilisateur': () => import('../pages/tenant/ProfilUtilisateur'),
  './pages/tenant/UtilisateursExploitant': () => import('../pages/tenant/UtilisateursExploitant'),
  './pages/tenant/ProfilsExploitant': () => import('../pages/tenant/ProfilsExploitant'),
  './pages/gestion/ClientsGestion': () => import('../pages/gestion/ClientsGestion'),
  './pages/gestion/EnginsGestion': () => import('../pages/gestion/EnginsGestion'),
  './pages/gestion/MarquesGestion': () => import('../pages/gestion/MarquesGestion'),
  './pages/gestion/ModelesGestion': () => import('../pages/gestion/ModelesGestion'),
  './pages/gestion/TypesModelesGestion': () => import('../pages/gestion/TypesModelesGestion'),
  './pages/gestion/MarquesAccGestion': () => import('../pages/gestion/MarquesAccGestion'),
  './pages/gestion/ModelesAccGestion': () => import('../pages/gestion/ModelesAccGestion'),
  './pages/gestion/TypesModelesAccGestion': () => import('../pages/gestion/TypesModelesAccGestion'),
};

export function useDynamicImport(componentPath, iconName) {
  const [component, setComponent] = useState(null);
  const [icon, setIcon] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const loadedPathRef = useRef(null);

  useEffect(() => {
    if (iconName && TablerIcons[iconName]) {
      setIcon(() => TablerIcons[iconName]);
    } else {
      setIcon(null);
    }
  }, [iconName]);

  useEffect(() => {
    setError(null);

    if (!componentPath) {
      loadedPathRef.current = null;
      setComponent(null);
      setLoading(false);
      return;
    }

    // Même page (ex. liste → modifier facture) : ne pas démonter / recharger le module
    if (loadedPathRef.current === componentPath) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setComponent(null);
    setLoading(true);

    const load = async () => {
      try {
        const importFn = componentMap[componentPath];
        if (!importFn) {
          throw new Error(`Composant non trouvé: ${componentPath}`);
        }

        const mod = await importFn();
        if (cancelled) return;
        loadedPathRef.current = componentPath;
        setComponent(() => mod.default);
      } catch (err) {
        if (cancelled) return;
        console.error('[useDynamicImport]', err);
        loadedPathRef.current = null;
        setError(err.message);
        setComponent(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [componentPath]);

  return { component, icon, loading, error };
}
